import Link from "next/link";
import React from "react";

interface ViewDetailsButtonProps {
  jobId: string;
}

const ViewDetailsButton: React.FC<ViewDetailsButtonProps> = ({ jobId }) => {
  const lang =
    typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
  const isArabic = lang === "ar";


  return (
    <div className="w-full basis-0 h-12 px-12 py-3.5 rounded-xl border border-[#ecedf5] dark:border-gray-700 text-center justify-center items-center gap-2 flex dark:hover:bg-gray-800 hover:bg-gray-100">
      <Link
        href={isArabic ? `/ar/careers/${jobId}` : `/en/careers/${jobId}`}
        className="text-[#4f8be0] text-sm font-semibold  leading-tight whitespace-nowrap"
      >
        {isArabic ? "عرض التفاصيل" : "View Details"}
      </Link>
    </div>
  );
};

export default ViewDetailsButton;
